var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738647 1.92365C0.738647 1.13523 1.37779 0.496094 2.16621 0.496094C2.95462 0.496094 3.59376 1.13523 3.59376 1.92365C3.59376 2.71207 2.95462 3.35121 2.16621 3.35121C1.37779 3.35121 0.738647 2.71207 0.738647 1.92365Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.738647 6.72268C0.738647 5.93426 1.37779 5.29512 2.16621 5.29512C2.95462 5.29512 3.59376 5.93426 3.59376 6.72268C3.59376 7.5111 2.95462 8.15024 2.16621 8.15024C1.37779 8.15024 0.738647 7.5111 0.738647 6.72268Z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.738647 11.5217C0.738647 10.7333 1.37779 10.0941 2.16621 10.0941C2.95462 10.0941 3.59376 10.7333 3.59376 11.5217C3.59376 12.3101 2.95462 12.9493 2.16621 12.9493C1.37779 12.9493 0.738647 12.3101 0.738647 11.5217Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.ea139dd314098760dd6b3d7ba0196594.svg";
export { ForwardRef as ReactComponent };